module.exports = "<span class=\"spinner\" ng-if=\"!vm.hasDownloadLink\">\n  <div class=\"bounce1\"></div>\n  <div class=\"bounce2\"></div>\n  <div class=\"bounce3\"></div>\n</span>\n<a ng-if=\"vm.hasDownloadLink\" href=\"{{vm.getDownloadLink()}}\" translate>AGENT_DOWNLOAD_LINK</a>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/agentDownloadLink/agentDownloadLink.html
// module id = 423
// module chunks = 1